import React, { useState } from "react";
import { Mail } from "lucide-react";
import logo from "../../assets/images/ai-worker-removebg.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getPasswordResetToken } from "../../services/oprations/authAPI";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [isLinkSent, setIsLinkSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    dispatch(getPasswordResetToken(email, setIsLinkSent));
  };

  const handleResend = () => {
    if (!email) return;
    dispatch(getPasswordResetToken(email, setIsLinkSent));
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Centered Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={logo}
            alt="Logo"
            width={180}
            height={40}
            className="object-contain cursor-pointer"
            onClick={() => navigate("/")}
          />
        </div>

        {/* Forgot Password Card */}
        <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-200 text-center">
          <h1 className="text-3xl font-bold text-slate-800 mb-2">
            Forgot password
          </h1>

          {!isLinkSent ? (
            <>
              <p className="text-slate-500 mb-8">
                Please enter your email address
              </p>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="text-left">
                  <label
                    htmlFor="email"
                    className="text-sm font-medium text-slate-600"
                  >
                    Email
                  </label>
                  <div className="relative mt-2">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                    <input
                      type="email"
                      id="email"
                      value={email}
                      placeholder="demo@gmail.com"
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full pl-10 pr-4 py-3 bg-slate-100 border border-slate-200 rounded-lg focus:ring-2 focus:ring-cyan-400 focus:border-cyan-400 outline-none transition"
                      required
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full bg-cyan-500 hover:bg-cyan-600 text-white font-bold py-3 px-4 rounded-lg transition"
                >
                  Request reset link
                </button>
              </form>

              <p className="text-sm text-slate-500 text-center mt-6">
                <button
                  onClick={() => navigate("/login")}
                  className="font-semibold text-cyan-500 hover:underline"
                >
                  Back to login
                </button>
              </p>
            </>
          ) : (
            <>
              <p className="text-slate-500 mb-8">
                Reset link sent to your email.
              </p>

              <div className="space-y-4">
                <button
                  onClick={handleResend}
                  className="w-full bg-cyan-500 hover:bg-cyan-600 text-white font-bold py-3 px-4 rounded-lg transition"
                >
                  Resend Link
                </button>

                <button
                  onClick={() => navigate("/login")}
                  className="w-full bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold py-3 px-4 rounded-lg transition"
                >
                  Back to login
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
